/**
 * CP-451: cuentas asignadas a un usuario del portal vendor.
 *
 * CoreDB guarda la restricción en `users.bank_account` (viene tal cual en
 * `GET /Admin/collector/login_user`) como los "Id Cliente" (`customer_id` de la
 * cuenta) separados por `##`: `"##ID1##"`, `"##ID1##ID2##"`. `"*"`, vacío o
 * ausente = sin restricción (ve todas las cuentas del collector). Hay valores
 * viejos sin los `##` de los bordes — se toman como un único Id Cliente.
 * Misma lectura que `formatAccounts` del portal vendor (FlutterFlow).
 */

/** `null` = todas las cuentas; si no, los Id Cliente asignados (sin repetidos, en orden). */
export function parseBankAccount(raw: unknown): string[] | null {
  const v = raw == null ? "" : String(raw).trim();
  if (!v || v === "*") return null;
  const ids = [...new Set(v.split("##").map((s) => s.trim()).filter(Boolean))];
  return ids.length ? ids : null;
}

/** ¿El usuario matchea la búsqueda por alguno de sus Id Cliente? */
export function accountsMatch(ids: string[] | null, q: string): boolean {
  const s = q.trim().toLowerCase();
  return !!s && !!ids && ids.some((id) => id.toLowerCase().includes(s));
}
